<template>
  <div>
    <div class="mb-0">{{ title }}:</div>
    <v-select
      v-model="value"
      ref="vSelect"
      :items="[]"
      :placeholder="selectedTitle"
      :menu-props="
        !isMobileView ? { contentClass: 'search-wide-input-menu' } : {}
      "
      outlined
      dense
      hide-details
    >
      <template v-slot:no-data>
        <v-container
          class="white pt-2 px-3 pb-8"
          style="border-radius: 8px"
        >
          <v-row
            class="my-0 mt-0 mb-5 align-center"
            dense
            style="
              border-bottom: 1px solid #ddd;
              padding-bottom: 5px;
              margin-bottom: 5px;
            "
            @click="close"
          >
            <v-col
              cols="1"
              text-center
            />
            <v-col
              :cols="9"
              class="text-center"
            >
              &nbsp;
            </v-col>
            <v-col
              :cols="2"
              class="text-right"
            >
              <v-btn
                small
                dark
                fab
                icon
                outlined
                class="form-close mr-2"
                color="green"
                @click="close"
              >
                <v-icon small>fa-check</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row
            no-gutters
            class="pt-5 mt-5 px-1"
          >
            <v-col
              cols="12"
              class="mt-3"
            >
              <v-range-slider
                v-model="rangeComputed"
                min="0"
                max="1000"
                color="#219bc8"
                background-color="white"
                track-color="grey lighten-3"
                thumb-label="always"
                hide-details
              />
            </v-col>
            <v-col
              cols="5"
              class="mt-1 text-center"
            >
              <v-text-field
                v-model="rangeComputed[0]"
                suffix="€"
                readonly
                disabled
                hide-details
              />
            </v-col>
            <v-col
              cols="2"
              class="mt-1 text-center justify-center"
            >
              -
            </v-col>
            <v-col
              cols="5"
              class="mt-1 text-center"
            >
              <v-text-field
                v-model="rangeComputed[1]"
                suffix="€"
                readonly
                disabled
                hide-details
              />
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-select>
  </div>
</template>

<script>
import sharedComputed from '@/methods/sharedComputed'

export default {
  name: 'SearchDayPriceSelect',

  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    options: {
      type: Array,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      selecting: true,
      // range: [0, 1300],
    }
  },

  computed: {
    ...sharedComputed,

    rangeComputed: {
      set(value) {
        this.$set(this.$store.state.searchFilters, 'dayPrice_from', value[0])
        this.$set(this.$store.state.searchFilters, 'dayPrice_to', value[1])
      },
      get() {
        return [
          this.$store.state.searchFilters.dayPrice_from,
          this.$store.state.searchFilters.dayPrice_to,
        ]
      },
    },

    selectedTitle() {
      return this.rangeComputed[0] + ' € - ' + this.rangeComputed[1] + ' €'
    },
  },

  methods: {
    select(value) {
      this.$emit('input', value)
      this.close()
    },

    close() {
      const searchEl = this.$refs.vSelect
      if (searchEl) {
        searchEl.blur()
      }
    },
  },
}
</script>
